export enum CertificateStatus {
  VALID = 'VALID',
  EXPIRING = 'EXPIRING',
  EXPIRED = 'EXPIRED',
}

export const CERTIFICATE_STATUS_LABELS: Record<CertificateStatus, string> = {
  [CertificateStatus.VALID]: 'Válido',
  [CertificateStatus.EXPIRING]: 'Expirando',
  [CertificateStatus.EXPIRED]: 'Expirado',
};

export const CERTIFICATE_STATUS_COLORS: Record<CertificateStatus, 'success' | 'warning' | 'error'> = {
  [CertificateStatus.VALID]: 'success',
  [CertificateStatus.EXPIRING]: 'warning',
  [CertificateStatus.EXPIRED]: 'error',
};

export interface Certificate {
  id: number;
  companyId: number;
  cnpj: string | null;
  issuer: string | null;
  subject: string | null;
  validFrom: string | null;
  validTo: string | null;
  fingerprint: string | null;
  originalFileName: string | null;
  status: CertificateStatus;
  createdAt: string;
  updatedAt: string;
}

export interface CertificateListResponse {
  data: Certificate[];
  total: number;
}
